export default "__VITE_ASSET__1d59d5cd__"